export default function UserInputIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 13C1 10.2386 3.23858 8 6 8H10C12.7614 8 15 10.2386 15 13V13.3406C15 13.7406 14.7613 14.0983 14.3782 14.2135C13.4019 14.5073 11.2758 15 8 15C4.7242 15 2.59813 14.5073 1.62181 14.2135C1.23874 14.0983 1 13.7406 1 13.3406V13Z"
        fill="var(--quaternery-color)"
      />
      <rect
        x="4"
        y="1"
        width="8"
        height="8"
        rx="4"
        fill="var(--text-secondary-color)"
      />
    </svg>
  );
}
